import { useTranslation } from "react-i18next"

import type { SmartRoutingStatusEnum } from "@/enums/smart-routing"
import {
  SmartRoutingStatusColorsEnum,
  smartRoutingStatusLabels,
} from "@/enums/smart-routing"

import { Badge } from "../ui/badge"

interface SmartRoutingStatusBadgeProps {
  status: string
}

export const SmartRoutingStatusBadge = ({
  status,
}: SmartRoutingStatusBadgeProps) => {
  const { t } = useTranslation()
  const knownStatus = status as SmartRoutingStatusEnum
  const label = smartRoutingStatusLabels[knownStatus]
    ? t(smartRoutingStatusLabels[knownStatus])
    : status
  const bgColor =
    SmartRoutingStatusColorsEnum[status] ?? "#9e9e9e"

  return (
    <Badge
      variant="none"
      className="flex h-fit items-center justify-start gap-1 rounded-full"
    >
      <div
        className="rounded-full px-2 py-1 text-white"
        style={{ backgroundColor: bgColor }}
      >
        {label}
      </div>
    </Badge>
  )
}
